import classNames from 'classnames/bind';
import Image from 'components/Image/Image';
import PropTypes from 'prop-types';
import styles from './ProfileImageLarge.module.css';

const cx = classNames.bind(styles);

const ProfileImageLarge = ({
  imageContainer,
  profileImage,
  withHover,
  onError,
}) => {
  return (
    <div
      className={cx(imageContainer, 'large-profile-image-wrapper', {
        withHover,
      })}
    >
      <Image className={cx('image')} src={profileImage} onError={onError} />
    </div>
  );
};

ProfileImageLarge.propTypes = {
  profileImage: PropTypes.string.isRequired,
  imageContainer: PropTypes.string,
  withHover: PropTypes.bool,
  onError: PropTypes.func,
};

ProfileImageLarge.defaultProps = {
  imageContainer: '',
  withHover: false,
  onError: undefined,
};

export default ProfileImageLarge;
